import { recordApi } from '../../redux/services/record';
import type { ExportSingleRecordBackgroundJobApiProps } from '../../redux/slices/background-job-slice';
import { appDispatch } from '../../redux/store-accessors';
import { ExportBackgroundJobHandler } from './export-background-job.handler';

export class ExportSingleRecordBackgroundJobHandler extends ExportBackgroundJobHandler<ExportSingleRecordBackgroundJobApiProps> {
  constructor(apiProps: ExportSingleRecordBackgroundJobApiProps, details?: Record<string, unknown>) {
    super(apiProps, { ...details });
  }

  protected dispatchCreateJob() {
    return appDispatch(
      recordApi.endpoints.createSingleExportJob.initiate({
        format: this.apiProps.format,
        recordId: this.apiProps.recordId,
        appendRecordlinksAsSeparatePages: this.apiProps.appendRecordlinksAsSeparatePages,
        appendSignaturePage: this.apiProps.appendSignaturePage,
        sectionIds: this.apiProps.sectionIds,
        includeHierarchy: this.apiProps.includeHierarchy,
      })
    ).unwrap();
  }
}
